/* eslint-disable camelcase */
import { getParentChildRelsOfChildRecord } from 'src/types/applicationEntityModel/applicationEntityModel';
import getFullTable from 'src/utils/entityOperations/getFullTable';
import getRecordByRecordId from 'src/utils/entityOperations/getRecordByRecordId';
export function getParentsOfChild(childRecordId) {
    const childRecord = getRecordByRecordId(childRecordId);
    const parentChildRels = getParentChildRelsOfChildRecord(childRecord);
    const acc = [];
    parentChildRels.forEach(pcr => {
        const relRecords = getFullTable(pcr.entities.parent_rel_children);
        const relRecord = relRecords.find(rel => rel[pcr.keys.children_rel_join_key] === childRecord.recordObject[pcr.keys.children_join_key]);
        if (!relRecord)
            return undefined;
        const parentId = relRecord[pcr.keys.parent_rel_join_key];
        const parentRecord = getFullTable(pcr.entities.parent).find(parent => parent.id === parentId);
        if (!parentRecord)
            return undefined;
        const parentRecordIds = {
            entityName: pcr.entities.parent,
            id: parentId,
            recordObject: parentRecord,
            asParentOfChild: childRecordId
        };
        acc.push(parentRecordIds);
    });
    return acc;
}
